export default __webpack_public_path__ + "locales/el-GR/Webhooks.json?hash=ed16e5308ef0eb8d34612bbedc0eeb5a";